export default __webpack_public_path__ + "static/media/10.e26ce5a6.mp3";